import axios from "../axios/index.js";

const urlGetCustomernAuth = "/api/get-customer-auth";
const urlUpdateCustomer = "/api/my-account/update/";
const urlChangePasswordCustomer = "/api/my-account/change-password";
const urlGetListOrder = "/api/my-account/order";
const urlGetListOrderDetail = "/api/my-account/order/detail";

export default {
    getCustomerAuth() {
        return axios.post(urlGetCustomernAuth);
    },

    update(params) {
        return axios.post(urlUpdateCustomer + params.id, params);
    },

    changePassword(params) {
        return axios.post(urlChangePasswordCustomer, params);
    },

    getListOrder(params) {
        return axios.post(urlGetListOrder, params);
    },

    getListOrderOrder(params) {
        return axios.post(urlGetListOrderDetail, params);
    },
};
